import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StepIndicator } from './step-indicator.component';

@NgModule({
  providers: [],
  exports: [StepIndicator],
  declarations: [StepIndicator],
  imports: [CommonModule],
})
export class StepIndicatorModule {
  constructor() {
  }
}
